var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00065 11.3327C4.63246 11.3327 4.33398 11.0342 4.33398 10.666L4.33399 1.33268C4.33399 0.964493 4.63246 0.666016 5.00065 0.666017C5.36884 0.666017 5.66732 0.964493 5.66732 1.33268L5.66732 10.666C5.66732 11.0342 5.36884 11.3327 5.00065 11.3327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47206 5.80409C9.21171 6.06444 8.7896 6.06444 8.52925 5.80409L5.00065 2.27549L1.47206 5.80409C1.21171 6.06444 0.789596 6.06444 0.529247 5.80409C0.268897 5.54374 0.268897 5.12163 0.529247 4.86128L4.52925 0.861278C4.7896 0.600928 5.21171 0.600928 5.47206 0.861278L9.47206 4.86128C9.73241 5.12163 9.73241 5.54374 9.47206 5.80409Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/Arrow-up.fd033bdf9f5c383dcf08d75b1ee0d163.svg";
export { ForwardRef as ReactComponent };